import apiClient from './client';

export interface AdItem {
  id: number;
  title: string;
  title_ar: string;
  image?: string | null;
  video_url?: string;
  youtube_embed_url?: string;
  placement?: string;
  link_url?: string;
  is_active: boolean;
  sort_order: number;
  starts_at?: string | null;
  ends_at?: string | null;
  impressions?: number;
  created_at?: string;
}

function toArray(payload: any): AdItem[] {
  if (Array.isArray(payload)) return payload as AdItem[];
  if (Array.isArray(payload?.results)) return payload.results as AdItem[];
  if (Array.isArray(payload?.data?.results)) return payload.data.results as AdItem[];
  if (Array.isArray(payload?.data)) return payload.data as AdItem[];
  return [];
}

export const adsApi = {
  list: async (params?: { placement?: string }) => {
    const { data } = await apiClient.get('/ads/', { params });
    return toArray(data);
  },
};

